<template>
    <footer>
        <b-container fluid>
          <a href="https://systemico.net" target="_blank" rel="noopener noreferrer">© {{ fecha }} Systemico® Technologies LLC</a>
        </b-container>
    </footer>
</template>

<script>
export default {
  name: 'footerC',
   data () {
     return {
      fecha: ''
     }
   },
 
   mounted () {
    this.fecha = new Date().getFullYear();
   },
}
</script>

<style lang="scss" scoped>
footer {
  margin-top:25px;
  padding: 5px;
  position: relative;
  text-align: center;
  a{
    color:#222222;
    font-size: 12px;
  }
}
</style>
